// extracted by mini-css-extract-plugin
export default {"section":"YBRB8li6B9PG2lCtUHoJ","sectionTitle":"TUZC1HXBagbSUaELbvqz","popularHotels":"WCY_7n79Q9falXMO6sTr"};